import React from 'react';
import { User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export default function Header() {
  const { profile } = useAuth();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/30 backdrop-blur-md border-b border-gray-800">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-8">
            <img 
              src="https://invoice-qr.com/ext-resources/logo-dark.png" 
              alt="QR Invoice Logo" 
              className="h-8"
            />
            
            {/* Navigation Links */}
            <nav className="hidden md:flex items-center gap-6">
              <a
                href="https://create.invoice-qr.com"
                className="text-[#c8c2bd] hover:text-white transition-colors text-sm"
                target="_blank"
                rel="noopener noreferrer"
              >
                Create Invoice
              </a>
              <a
                href="https://invoice-qr.com"
                className="text-[#c8c2bd] hover:text-white transition-colors text-sm"
                target="_blank"
                rel="noopener noreferrer"
              >
                Website
              </a>
            </nav>
          </div>
          
          <nav className="flex items-center gap-4">
            <a
              href="https://dashboard.invoice-qr.com"
              className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm text-[#c8c2bd] hover:bg-black/50 transition-colors"
            >
              {profile && (
                <div className="flex items-center gap-2 border-r border-gray-700 pr-3 mr-1">
                  <User className="w-4 h-4" />
                  <span>{profile.name}</span>
                </div>
              )}
              Dashboard
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}